import axios from '@/modules/axiosInterceptor';
import { apiUrlPrefix } from '@/modules/staticData';

export default {
  mixins: [apiUrlPrefix],
  methods: {
    getGroup(groupObj, suppressNotifications) {
      const uid = groupObj.id;
      const deferred = new Promise((resolve, reject) => {
        axios
          .get(`${apiUrlPrefix}groups/${uid}`)
          .then((r) => {
            resolve(r.data.group);
          })
          .catch((r) => {
            if (!suppressNotifications) {
              const errorMessage = this.handleFormErrors(r.response.data);
              this.$root.$emit('notification-add', {
                content: `Unable to fetch the group: ${errorMessage}`,
                variant: 'danger',
                ttl: 10000,
              });
              reject(errorMessage);
            } else {
              reject();
            }
          })
          .finally(() => {
            this.formLoading = false;
          });
      });
      return deferred;
    },
    deleteGroup(groupObj) {
      const uid = groupObj.id;
      const deferred = new Promise((resolve, reject) => {
        this.$root.$emit('modal-show-confirmation', {
          title: groupObj.name,
          body: 'Delete the group permanently?',
          cbConfirm: () => {
            this.formLoading = true;
            axios
              .delete(`${apiUrlPrefix}groups/${uid}`)
              .then(() => {
                this.$root.$emit('notification-add', { content: 'Group deleted.' });
                resolve();
              })
              .catch((r) => {
                const errorMessage = this.handleFormErrors(r.response.data);
                this.$root.$emit('notification-add', {
                  content: `Unable to delete the group: ${errorMessage}`,
                  variant: 'danger',
                  ttl: 10000,
                });
                reject(errorMessage);
              })
              .finally(() => {
                this.formLoading = false;
              });
          },
          confirmText: 'Delete',
          cancelText: 'Cancel',
        });
      });
      return deferred;
    },
    updateGroup(groupObj) {
      this.formLoading = true;
      const deferred = new Promise((resolve, reject) => {
        axios
          .put(`${apiUrlPrefix}groups`, { ...groupObj })
          .then((r) => {
            this.$root.$emit('notification-add', { content: 'Group updated.' });
            resolve(r.data.group);
          })
          .catch((r) => {
            const errorMessage = this.handleFormErrors(r.response.data);
            this.$root.$emit('notification-add', {
              content: `Unable to update the group: ${errorMessage}`,
              variant: 'danger',
              ttl: 10000,
            });
            reject(errorMessage);
          })
          .finally(() => {
            this.formLoading = false;
          });
      });
      return deferred;
    },
    createGroup(groupObj, suppressRedirect = false) {
      this.formLoading = true;
      const deferred = new Promise((resolve, reject) => {
        axios
          .post(`${apiUrlPrefix}groups`, { ...groupObj })
          .then((r) => {
            this.$root.$emit('notification-add', { content: 'Group created.' });
            if (!suppressRedirect) {
              this.$router.push({
                name: 'showGroup',
                params: { id: r.data.group.id, groupObj: r.data.group },
              });
            }
            resolve(r.data.group);
          })
          .catch((r) => {
            const errorMessage = this.handleFormErrors(r.response.data);
            this.$root.$emit('notification-add', {
              content: `Unable to create the group: ${errorMessage}`,
              variant: 'danger',
              ttl: 10000,
            });
            reject(errorMessage);
          })
          .finally(() => {
            this.formLoading = false;
          });
      });
      return deferred;
    },
    uploadExcel(formData) {
      this.formLoading = true;
      const deferred = new Promise((resolve, reject) => {
        axios
          .post(`${apiUrlPrefix}groups/excel`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((r) => {
            resolve(r.data);
          })
          .catch((r) => {
            const errorMessage = this.handleFormErrors(r.response.data);
            this.$root.$emit('notification-add', {
              content: `Unable to upload file: ${errorMessage}`,
              variant: 'danger',
              ttl: 10000,
            });
            reject(errorMessage);
          })
          .finally(() => {
            this.formLoading = false;
          });
      });
      return deferred;
    },
  },
};
